module.exports = __webpack_public_path__ + "img/success_warmness_illustration.ddf81480.jpg";